<template>
    <div class="custom-payment-wrapper py-5" style="padding-top: 50px !important; min-height: 100vh; width: 100vw; overflow-x: hidden; margin: 0;">
        <div class="container bg-white mt-5 shadow rounded-5 overflow-hidden" style="width: 70% !important;">
            <div class="row">
                <div class="col-12 px-0 h-100">
                    <div class="d-flex align-items-center  ps-5 pt-4">
                        <div class="text-center">
                            <div class="pe-4"> 
                                <img class="soimg" src="/../images/logo/logox.png" alt="">
                            </div>
                        </div>
                        <div class="ms-5 d-none d-md-block">
                            <p class="fw-bold">Sokoto State Internal Revenue Service</p>
                            <p class="text-muted" style="font-size: 12px;">No. 4 Kano Road, Investment House Sokoto, <br>Sokoto State, Nigeria</p>
                        </div>
                    </div>
                    <hr>
                    <div class="px-5 pt-4">
                        <div class="mt-5 p-4">
                            <div v-if="status == 'not_found'">
                                <div class="mt-5 p-4 text-center">
                                    <img src="/../images/Failed.svg" class="img-fluid" alt="BootstrapBrain Logo" width="100" height="44">
                                </div>
                                <h5 class="fw-semibold text-center mb-4 ">Invoice not found.</h5>
                            </div>
                            <h5 class="fw-semibold text-center text-uppercase mb-4 ">Search Invoice Number</h5>
                            
                              <form id="registerform" class="job-panel-filter" @submit.prevent="searchForInvoice" @keydown="invoiceForm.errors.clear($event.target.name)">
                                    <div class="row g-md-0 g-2">
                                        <div class="col-md-12 w-100">
                                            <div class="w-75 mx-auto">
                                                <input class="form-control border-2 border-success" :class="{ 'is-invalid': invoiceForm.errors.has('invoice_no') }" type="text" value="" v-model="invoiceForm.invoice_no" :placeholder="'Enter Invoice No.'">
                                            
                                                <show-error :form-name="invoiceForm" prop-name="invoice_no"></show-error>
                                            </div>
                                        </div>
                                        <!--end col-->

                                        <div class="col-md-12 my-4">
                                            <div class="h-100 text-center">
                                                <button-spinner
                                                    :is-loading="invoiceForm.isLoading" 
                                                    :disabled="invoiceForm.isLoading"
                                                    
                                                    class="btn btn-secondary submit-btn px-4 h-100"
                                                    style="height: 39px; color: #fff;"
                                                    >
                                                    <i class="fa-solid fa-magnifying-glass me-2"></i>Search
                                                </button-spinner>
                                            </div>
                                        </div>
                                        <!--end col-->
                                    </div>
                                    <!--end row-->
                                </form>
                        </div>
                    </div>
                </div>
            </div>
            </div>
    </div>
  </template>
  
  <script>
    export default {
        data() {
            return {
                invoiceForm: new Form({
                    isLoading: false,
                    invoice_no: ''
                }),
                status: ''
            }
        },
         mounted(){
            const link = document.createElement('link');
            link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
            link.rel = 'stylesheet';
            link.id = 'bootstrap-css';
            document.head.appendChild(link);
        },
        beforeUnmount() {
            const link = document.getElementById('bootstrap-css');
            if (link) {
            document.head.removeChild(link);
            }
        },
        methods: {
            searchForInvoice(){
                this.invoiceForm.isLoading = true;
                this.invoiceForm.post('/api/search-by-invoice_no')
                    .then(response => {
                        this.invoiceForm.invoice_no = response.invoice_no;
                        this.invoiceForm.isLoading = false;
                        this.$router.push('/make-payment/' + response.invoice_no);
                        
                    })
                    .catch(error => {
                        this.invoiceForm.isLoading = false;
                        this.status = 'not_found';
                    });
            },
            
            getConfig(config){
                return helper.getConfig(config);
            }
        }
    }
</script>

<style scoped>
  
p {

    margin: 0px;
}

.custom-payment-wrapper {
    font-family: 'Inter', sans-serif !important;
    background-color: #094824;
    padding-top: 50px;
  }

.container {
    background-color: #f9fbff;
    height: 80vh;
    overflow: hidden;
}

button {
background: linear-gradient(to bottom right, #198754, #14783f);
-webkit-text-fill-color: #ffffff;
border: #094824;
}

button:hover {
background: linear-gradient(to bottom right, #14783f, #198754);
}

.soimg{
    width:100px ;

}
</style>
  